import type React from 'react';
import { Component } from 'react';
import findIndex from 'lodash/findIndex';
import styled from 'styled-components';
import { stacked } from 'app/shared/styles/_spacing';

import controller from './controller';
import Select from 'app/shared/core/Select';

// Select component accepts value via spread props but PropTypes don't declare it
const TypedSelect = Select as React.ComponentType<{
  'aria-label'?: string;
  label?: string;
  required?: boolean;
  value?: number;
  onChange?: (e: React.ChangeEvent<HTMLSelectElement>) => void;
  children?: React.ReactNode;
}>;

type FloorplanModel = {
  beds: number;
  baths: number;
  key: string;
};

type Listing = {
  floorplans: Array<FloorplanModel>;
};

type BedsBathsSelectProps = {
  listing: Listing;
  onBedsBathsSelect: (selection: { beds: number; baths: number }) => void;
  beds: number;
  baths: number;
};

const StyledContainer = styled.div`
  ${stacked._2x};
`;
class BedsBathsSelect extends Component<BedsBathsSelectProps> {
  handleSelect = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const { listing, onBedsBathsSelect } = this.props;
    const model = controller.dedupeBedsBathsOptions(listing.floorplans)[Number(e.target.value)];
    onBedsBathsSelect({ beds: model.beds, baths: model.baths });
  };
  render() {
    const { listing, beds, baths } = this.props;
    const dedupedModels = controller.dedupeBedsBathsOptions(listing.floorplans);
    return (
      <StyledContainer className="BedsBathsSelect">
        <TypedSelect
          aria-label="bed and bath"
          label="Unit"
          required
          value={findIndex(dedupedModels, { beds, baths })}
          onChange={this.handleSelect}
        >
          {dedupedModels.map((model, idx) => {
            return (
              <option value={idx} key={`${model.beds}-${model.baths}`}>
                {model.key}
              </option>
            );
          })}
        </TypedSelect>
      </StyledContainer>
    );
  }
}

export default BedsBathsSelect;
